import React from 'react'
import Header from '../Components/Header/Header'

const Home = () => {
    return (
        <div>
            <Header />
            <div className="max-w-[1280px] mx-auto sm:p-[40px] p-[40px_20px]">
                <div>
                    <h3 className="font-sacr sm:text-[78px] text-[50px] text-center text-[#1b1b1b]">Applogika</h3>
                    <div className='flex items-center gap-6 sm:mt-[60px] mt-[30px]'>
                        <div className='h-[1px] bg-[#1b1b1b] w-full'></div>
                        <h4 className='font-sacr text-[#1b1b1b] text-[41px]'>Paysa</h4>
                        <div className='h-[1px] bg-[#1b1b1b] w-full'></div>
                    </div>
                </div>
                <div className='font-raleway mt-[40px] grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 lg:gap-[60px] gap-[40px] '>
                    <div>
                        <h3 className='text-[18px] tracking-[0.107em] text-[#1b1b1b] sm:sm:h-[45px]'>ACCELERATE B2B PAYMENTS IN 4 STEPS</h3>
                        <ul className='text-[#5e5e5e] list-disc mt-8 pl-10'>
                            <li className='sm:text-[18px] text-[16px]'>Capture</li>
                            <li className='sm:text-[18px] text-[16px]'>Approve</li>
                            <li className='sm:text-[18px] text-[16px]'>Pay</li>
                            <li className='sm:text-[18px] text-[16px]'>Synchronize</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className='text-[18px] tracking-[0.107em] text-[#1b1b1b] sm:sm:h-[45px]'>SMART PAY</h3>
                        <div className='text-[#5e5e5e] mt-8'>
                            <p className='sm:text-[18px] text-[16px]'>With access to millions of vendors over the paisa network and more payment options—from  ACH,Credit Card, e-check. Wire Transfer.</p>
                        </div>
                    </div>
                    <div>
                        <h3 className='text-[18px] tracking-[0.107em] text-[#1b1b1b] sm:h-[45px]'>PAYMENT SERVICES</h3>
                        <ul className='text-[#5e5e5e] list-disc mt-8 pl-10'>
                            <li className='sm:text-[18px] text-[16px]'>ACH</li>
                            <li className='sm:text-[18px] text-[16px]'>CARD PAY</li>
                            <li className='sm:text-[18px] text-[16px]'>eCheque</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className='text-[18px] tracking-[0.107em] text-[#1b1b1b]'>VISIBILITY</h3>
                        <div className='text-[#5e5e5e] mt-6'>
                            <p className='text-[18px]'>Get the complete picture of money coming in and out of your business to make more informed decisions, faster.</p>
                            <p className='sm:text-[18px] text-[16px] mt-5'>Automated entry using AI , Analytics</p>
                        </div>
                    </div>
                    <div>
                        <h3 className='text-[18px] tracking-[0.107em] text-[#1b1b1b]'>COMPLIANCE</h3>
                        <ul className='text-[#5e5e5e] list-disc mt-6 pl-10'>
                            <li className='sm:text-[18px] text-[16px]'>Secured  & Trusted Network</li>
                            <li className='sm:text-[18px] text-[16px]'>PCI Certified</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className='text-[18px] tracking-[0.107em] text-[#1b1b1b]'>INTEGRATION</h3>
                        <ul className='text-[#5e5e5e] list-disc mt-6 pl-10'>
                            <li className='sm:text-[18px] text-[16px]'>Microsoft Net suite</li>
                            <li className='sm:text-[18px] text-[16px]'>Oracle ERP ( Coming soon )</li>
                            <li className='sm:text-[18px] text-[16px]'>Oracle ERP ( Coming soon )</li>
                            <li className='sm:text-[18px] text-[16px]'>Microsoft Netsuite</li>
                        </ul>
                    </div>
                </div>
                <div className='mt-[40px]'>
                    <div className='flex items-center gap-6 mt-[60px]'>
                        <div className='h-[1px] bg-[#1b1b1b] w-full'></div>
                        <h4 className='font-sacr text-[#1b1b1b] text-[41px]'>PaySA</h4>
                        <div className='h-[1px] bg-[#1b1b1b] w-full'></div>
                    </div>
                    <h3 className='font-raleway text-center my-5 text-[18px] text-[#5e5e5e]'>Check out this great video</h3>
                    <div className='md:h-[620px] h-[300px] relative w-full'>
                        <iframe title='player' src="https://player.vimeo.com/video/818430605?h=ff630b8d88&autoplay=0&title=0&portrait=0&byline=0&badge=0" frameborder="0" className='h-full w-full max-h-[620px] top-0 absolute left-0'></iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home